<template>
    <div>
        <el-row>
            <el-col :span="24">
                <el-form :inline="true" :model="orderInfo" :rules="rules" ref="orderInfo" label-width="100px" class="orderinfo-form" size="mini">
                    <el-row>
                            <el-form-item label="订单编号" prop="orderCode">
                                <el-input v-model="orderInfo.orderCode" :readonly="true"></el-input>
                            </el-form-item>
                            <el-form-item label="客户姓名" prop="customerName">
                                <el-input v-model="orderInfo.customerName" :readonly="true"></el-input>
                            </el-form-item>
                            <el-form-item label="载体名称" prop="carrierName">
                                <el-input v-model="orderInfo.carrierName" :readonly="true"></el-input>
                            </el-form-item>
                            <el-form-item label="检测引物" prop="detectionPrimer" v-if="isShowDetectionPrimer">
                                <el-input v-model="orderInfo.detectionPrimer" :readonly="true"></el-input>
                            </el-form-item>
                            <el-form-item label="抗性" prop="resistance">
                                <el-input v-model="orderInfo.resistance" :readonly="true"></el-input>
                            </el-form-item>
                            <el-form-item label="菌株" prop="bacterialStrain">
                                <el-input v-model="orderInfo.bacterialStrain" :readonly="true"></el-input>
                            </el-form-item>
                            <el-form-item label="样品编号" prop="sampleNum">
                                <el-input v-model="orderInfo.sampleNum" :readonly="true"></el-input>
                            </el-form-item>
                            <el-tooltip :content="experimentNumContent" placement="top">
                                <el-form-item label="实验编号" prop="experimentNum">
                                    <el-input v-model="orderInfo.experimentNum" :readonly="true"></el-input>
                                </el-form-item>
                            </el-tooltip>
                            <el-form-item label="收货地址" prop="address">
                                <el-input v-model="orderInfo.address" :readonly="true"></el-input>
                            </el-form-item>
                            <el-form-item label="插入片段" prop="insertFragment">
                                <el-input v-model="orderInfo.insertFragment" :readonly="true"></el-input>
                            </el-form-item>
                            <el-form-item label="是否已经纯化" prop="isPurifyingDesc">
                                <el-input v-model="orderInfo.isPurifyingDesc" :readonly="true"></el-input>
                            </el-form-item>
                            <el-form-item label="上游位点" prop="upstreamSite">
                                <el-input v-model="orderInfo.upstreamSite" :readonly="true"></el-input>
                            </el-form-item>
                            <el-form-item label="下游位点" prop="downstreamSite">
                                <el-input v-model="orderInfo.downstreamSite" :readonly="true"></el-input>
                            </el-form-item>
                            <el-form-item label="是否测序" prop="isSequencingDesc">
                                <el-input v-model="orderInfo.isSequencingDesc" :readonly="true"></el-input>
                            </el-form-item>
                            <el-form-item label="送测公司" prop="sequenceCompany">
                                <el-input v-model="orderInfo.sequenceCompany" :readonly="true"></el-input>
                            </el-form-item>
                            <el-form-item label="阳性克隆数" prop="positiveCloneNum">
                                <el-input v-model="orderInfo.positiveCloneNum" :readonly="true"></el-input>
                            </el-form-item>
                            <el-form-item label="测序引物名称" prop="sequencePrimerName">
                                <el-input v-model="orderInfo.sequencePrimerName" :readonly="true"></el-input>
                            </el-form-item>
                            <el-form-item label="测序邮箱" prop="email" v-if="isShowEmail">
                                <el-input v-model="orderInfo.email" :readonly="true"></el-input>
                            </el-form-item>
                            <el-form-item label="订单状态" prop="orderStatusDesc">
                                <el-input v-model="orderInfo.orderStatusDesc" :readonly="true"></el-input>
                            </el-form-item>
                            
                            <el-form-item label="加测引物碱基数" v-if="isShowCompanyKtr">
                                <el-input v-model="orderInfo.companyKtr" :readonly="true"></el-input>
                            </el-form-item>
                            <el-form-item label="测序反应数" prop="companyJkr" v-if="isShowCompanyJkr">
                                <el-input v-model="orderInfo.companyJkr" :readonly="true"></el-input>
                            </el-form-item>
                            <el-form-item label="生工" v-if="isShowCompanySg">
                                <el-input v-model="orderInfo.companySg" :readonly="true"></el-input>
                            </el-form-item>
                            <el-form-item label="擎科" v-if="isShowCompanyQk">
                                <el-input v-model="orderInfo.companyQk" :readonly="true"></el-input>
                            </el-form-item>
                            <el-form-item label="合测" prop="companyHc" v-if="isShowCompanyHc">
                                <el-input v-model="orderInfo.companyHc" :readonly="true"></el-input>
                            </el-form-item>
                            
                            <el-form-item label="测序结果" prop="resultFileName">
                                <el-input v-model="orderInfo.resultFileName" :readonly="true">
                                    <!-- <el-button  slot="append"  @click="toDownload" style="background-color:#67C23A;color:#FFF;border-color:#67C23A;">下载</el-button> -->
                                </el-input>
                            </el-form-item>
                            <el-form-item label="订单金额" prop="orderAmount">
                                <el-input v-model="orderInfo.orderAmount" :readonly="true"></el-input>
                            </el-form-item>
                            <el-form-item label="支付意愿确认" prop="payWillingnessDesc">
                                <el-input v-model="orderInfo.payWillingnessDesc" :readonly="true"></el-input>
                            </el-form-item>
                            <el-form-item label="客户结算金额" prop="customSettlementAmount">
                                <el-input v-model="orderInfo.customSettlementAmount" :readonly="true"></el-input>
                            </el-form-item>
                            <el-form-item label="代理结算金额" prop="agentSettlementAmount">
                                <el-input v-model="orderInfo.agentSettlementAmount" :readonly="true"></el-input>
                            </el-form-item>
                            <el-form-item label="客户等级" prop="userLevel">
                                <el-input v-model="orderInfo.userLevel" :readonly="true"></el-input>
                            </el-form-item>
                            <el-form-item label="客户余额" prop="customBalance">
                                <el-input v-model="orderInfo.customBalance" :readonly="true"></el-input>
                            </el-form-item>
                            <el-form-item label="代理余额" prop="agentBalance">
                                <el-input v-model="orderInfo.agentBalance" :readonly="true"></el-input>
                            </el-form-item>
                            <el-form-item label="归属责任客户" prop="attributableCustomer">
                                <el-input v-model="orderInfo.attributableCustomer" :readonly="true"></el-input>
                                <!-- <el-input v-model="orderInfo.attrCustomer" :readonly="true"></el-input> -->
                            </el-form-item>
                    </el-row>
                    <el-row>
                        <el-form-item label="插入片段序列" prop="insertFragmentSeq">
                            <el-input style="display:block;width: 130%" type="textarea" :rows="10" maxlength="10000" show-word-limit v-model="orderInfo.insertFragmentSeq" :readonly="true"></el-input>
                        </el-form-item>
                    </el-row>
                    <!-- <el-divider>构建系统</el-divider>
                    <div v-for="(item, index) in welcomeContents" :key="index">
                        <span>{{item}}</span>
                    </div> -->
                </el-form>
            </el-col>
        </el-row>
        
        
        <!-- <el-dialog title="用户列表" :visible.sync="userDialogVisible" append-to-body>
            <UserSearch></UserSearch>
        </el-dialog> -->
    </div>
</template>

<script>

// import UserSearch from '../user/UserSearch.vue';

export default {
    name: "OrderInfoView",
    props: ["orderInfoProp"],
    components: {
        // UserSearch
    },
    data() {
        return {
            orderInfo: {
            },
            rules: {
                
            },
            isDisabled: true,
            deliverys: [],
            isReceipts: [],
            confirmationReviews: [],
            userDialogVisible: false,
            salerButton: false,
            receiverButton: false,
            operatorButton: false,
            currentDialog: "",
            isShowCompanySg:false,
            isShowCompanyKtr:false,
            isShowCompanyQk:false,
            isShowCompanyHc:false,
            isShowCompanyJkr:false,
            experimentNumTooltipDisabled: true,
            experimentNumContent:'',
            quotationAmountTooltipDisabled: true,
            quotationAmountContent: '',
            fieldHis:{},
            isQuotationAmount: false,
            labelStyle:{"text-align":"right","margin-left":"100px"},
            welcomeContents:[],
            isShowEmail:false,
            isShowDetectionPrimer: false,
        };
    },
    methods: {
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        queryDicts(dictType) {
            let condition = {value:dictType};
            this.$axios.post("/dictionary/findByDictType",condition).then(
                res=>{
                    if(res.data.status === "success"){
                        if(dictType === 'AUDIT_STATUS') {
                            this.confirmationReviews = res.data.result;
                        } else if(dictType === 'YES_NO') {
                            this.isReceipts = res.data.result;
                        }else if(dictType === 'DELIVERY_STATUS') {
                            this.deliverys = res.data.result;
                        }
                        
                    }
                },
                error=>{
                    this.$message.error(error.message);
                }
            )
        },
        
        queryWelcomeContent() {
            var welcome = {
                'roleCode': this.user.roleCode
            }
            this.$axios.post("/welcome/findByRoleCode",welcome).then(
                res=>{
                    if(res.data.status === "success"){
                        this.welcomeContents = res.data.result;                    
                    } else {
                        this.$message.error(res.data.message);
                    }
                },
                error=>{
                    this.$message.error(error.message);
                }
            )
        },
        toDownload() {
            if(!this.orderInfo.resultFileName) {
                this.$message.error('测序结果文件不存在，等待管理员上传之后，再进行下载！');
            }
            var param = {
                id:this.orderInfo.orderId
            }
            this.$axios.post("/order/downloadFile",param,
            {
                responseType:"blob"//注意 需要规定后台返回文件流格式
            }).then(
                res=>{
                    if (res) {
                        let fileNames = res.headers['content-disposition'] //获取到Content-Disposition;filename
                        let regFileNames = fileNames.match(/=(.*)$/)[1];
                        const link = document.createElement("a");
                        let blob = new Blob([res.data], { type: "application/vnd.ms-excel" });  //文件流处理
                        link.style.display = "none";  //去除a标签的样式
                        link.href = URL.createObjectURL(blob);
                        link.download = decodeURIComponent(regFileNames);
                        document.body.appendChild(link);
                        //模拟点击事件
                        link.click();
                        this.$message.success('下载成功');
                        this.loading = false;
                    }
                },
                error=>{
                    this.$message.error(error.message);
                    this.loading = false;
                }
            )
        },
        queryFieldHis() {
            let param = {
                value: this.orderInfo.orderId
            }
            this.$axios.post("/orderFieldHis/findByOrderId",param).then(
                res=>{
                    if(res.data.status === "success"){
                        this.experimentNumContent = res.data.result;
                    } else {
                        this.$message.error(res.data.message);
                    }
                },
                error=>{
                    this.$message.error(error.message);
                }
            )
        }
    },
    created() {
        this.orderInfo = this.orderInfoProp;
        this.orderInfo.term
        if(this.orderInfo.isOverTime) {
            this.$set(this.orderInfo,"term",this.orderInfo.term + " " + this.orderInfo.isOverTime);
        }
        this.$set(this.orderInfo,"",)
        this.queryDicts("AUDIT_STATUS");
        this.queryDicts("YES_NO");
        this.queryDicts("DELIVERY_STATUS");
        this.user = JSON.parse(window.localStorage.getItem("user"));
        this.queryWelcomeContent();

        if(this.user.roleCode === 'SUPER' || this.user.roleCode === 'ADMIN') {
            this.isShowCompanyKtr = true;
            this.isShowCompanyQk = true;
            this.isShowCompanySg = true;
            this.isShowCompanyHc = true;
            this.isShowCompanyJkr = true;
            this.isShowEmail = true;
            this.isShowDetectionPrimer = true;
        } else if(this.user.roleCode === 'AGENT') {
            // this.isShowCompanyKtr = false;
            this.isShowCompanyKtr = true;
            this.isShowCompanyJkr = true;
        } else if(this.user.roleCode === 'RESPONSIBLE') {
            this.isShowCompanyKtr = true;
            this.isShowCompanyQk = true;
            this.isShowCompanySg = true;
            this.isShowCompanyHc = true;
            this.isShowCompanyJkr = true;
            this.isShowEmail = true;
        } else if(this.user.roleCode === 'ORDINARY') {
            // this.isShowCompanyKtr = false;
            this.isShowCompanyKtr = true;
            this.isShowCompanyJkr = true;
        }
        this.queryFieldHis();
    },
    mounted() {
    },
    beforeDestroy() {
    }
}


</script>

<style scoped>

    .orderinfo-form {
       margin: 10px 10px 10px 10px;
   }

   .el-select {
        width: 200px;
    }

    .el-input {
        width: 210px;
    }
    .el-date-picker {
        width: 200px;
        background-color: green;
    }
    .el-cascader {
        width: 200px;
    }
    .el-input-number {
        width: 220px;
    }
    .el-button >:span {
        background-color: blue;
    }

</style>
